/*
 * @Author: Teemo Ding
 * @Date: 2021-09-09 16:11:10
 * @LastEditTime: 2022-06-10 16:55:53
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelRegistration/CustomerRegistrationMethod/index.tsx
 */
import { get } from 'lodash';
import React from 'react';
import { OriCheckbox } from 'src/components/Antd/Checkbox/Checkbox';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { RegistrationErrorContext } from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelRegistration/ErrorContext';
import { ChannelType } from 'src/types/common/SalesChannel';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { Icon } from '@/src/tools/icon';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

const Method = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { methodError, setMethodError } = React.useContext(
    RegistrationErrorContext,
  );
  const type = useSalesChannelType();
  const isMini = type === ChannelType.MiniProgram;
  const [loginMethod, setLoginMethod] = React.useState('');

  const {
    data,
    onChange,
    setHasModified,
    supportThirdPartyLogin,
    disableEdit,
  } = props;
  const enableMobileRegistration = get(data, 'enableMobileRegistration');
  const enableEmailRegistration = get(data, 'enableEmailRegistration');
  const enableThirdPartyLoginRegistration = get(
    data,
    'enableThirdPartyLoginRegistration',
  );
  React.useEffect(() => {
    if (supportThirdPartyLogin === false && enableThirdPartyLoginRegistration) {
      if (onChange) {
        onChange({
          enableMobileRegistration,
          enableEmailRegistration,
          enableThirdPartyLoginRegistration: false,
        });
      }
    }
  }, [supportThirdPartyLogin]);

  function handleOnChange(e, key) {
    setHasModified(true);
    setMethodError(false);
    const checked = e.target.checked;

    if (!checked) {
      let methodText = '';
      if (key === 'enableMobileRegistration') {
        methodText = getI18n('general.customer.mobileNumber');
      } else if (key === 'enableEmailRegistration') {
        methodText = getI18n('general.customer.email');
      } else if (key === 'enableThirdPartyLoginRegistration') {
        methodText = getI18n('salesChannelRegistration.index.thirdpartylogin');
      }
      setLoginMethod(methodText);
    } else {
      setLoginMethod('');
    }

    if (onChange) {
      onChange({
        ...(data || {}),
        [key]: checked,
      });
    }
  }

  return (
    <SectionWrapper
      title={getI18n(
        'salesChannelRegistration.index.customerRegistrationMethods',
      )}>
      <div className={css.group}>
        {methodError && (
          <div className={css.error} id='salesChannelRegistrationMethod'>
            {getI18n(
              'salesChannelRegistration.index.customerRegistrationMethodsError',
            )}
          </div>
        )}
        <OriCheckbox
          onChange={(e) => {
            handleOnChange(e, 'enableMobileRegistration');
          }}
          disabled={disableEdit}
          className={css.checkbox}
          checked={enableMobileRegistration}>
          {getI18n('general.customer.mobileNumber')}
        </OriCheckbox>
        <OriCheckbox
          onChange={(e) => {
            handleOnChange(e, 'enableEmailRegistration');
          }}
          disabled={disableEdit}
          className={isMini ? css.checkboxLast : css.checkbox}
          checked={enableEmailRegistration}>
          {getI18n('general.customer.email')}
        </OriCheckbox>
        {!isMini && (
          <OriCheckbox
            onChange={(e) => {
              handleOnChange(e, 'enableThirdPartyLoginRegistration');
            }}
            className={css.checkboxLast}
            disabled={!supportThirdPartyLogin || disableEdit}
            checked={enableThirdPartyLoginRegistration}>
            {getI18n('salesChannelRegistration.index.thirdpartylogin')}
          </OriCheckbox>
        )}
        {loginMethod && (
          <div className={css.nav}>
            <Icon type='iconinfo2' className={css.info} />
            <span>
              {replaceI18nVariables(
                getI18n('salesChannelRegistration.index.methodtips'),
                loginMethod,
                loginMethod,
              )}
            </span>
          </div>
        )}
      </div>
    </SectionWrapper>
  );
};
export default Method;
